<template>
    <EditParent />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    
    import EditParent from "@/components/Parent/EditParent.vue";
  
    export default defineComponent({
      name: "EditParentPage",
      components: {
        
        EditParent,
      },
    });
  </script>